import React, { Fragment, useEffect, useState } from 'react';
import { congDoanService, homeService } from '../../services';
import { Link } from 'react-router-dom';
import { MAX_ITEMS_PER_PAGE } from '../../helpers/constants';
import { Form, Input, Pagination, message } from 'antd';
import Swal from 'sweetalert2';
import MoveButtons from '../../components/MoveButtons';

export const CongDoan = () => {
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();
    const [totalItems, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [lstDanhSach, setLstDanhSach] = useState<any[]>([]);

    const fetchData = (pageNumber: number, keySearch: any) => {
        setLoading(true);
        congDoanService.filterList(pageNumber - 1, MAX_ITEMS_PER_PAGE, null, keySearch)
            .then((response) => {
                if (response.status === 200) {
                    setTotal(response.headers['x-total-count']);
                    setLstDanhSach(response.data);
                } else {
                    message.error({ content: response.message, duration: 2 });
                }
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData(currentPage, null);
        // Fetch other data (lstTenThanh, lstCongDoan, etc.)
    }, [currentPage]);

    const onPageChanged = (pageNumber: number) => {
        setCurrentPage(pageNumber);
    };

    const refreshData = async () => {
        try {
            const values = await form.validateFields();
            fetchData(1, values.keySearch);
            setCurrentPage(1);
        } catch (error: any) {
            message.error({ content: "Chưa chọn năm", duration: 2 });
        }
    };

    const handleDelete = async (id: any) => {
        const result = await Swal.fire({
            title: 'Xác nhận xóa Cộng đoàn này?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Xóa',
            cancelButtonText: 'Hủy',
            reverseButtons: true,
        });

        if (result.isConfirmed) {
            setLoading(true);
            try {
                const response = await congDoanService.deleteById(id);
                if (response.code === 0) {
                    message.success('Xóa Cộng Đoàn thành công');
                    const values = await form.validateFields();
                    setCurrentPage(1);
                    fetchData(1, values.keySearch);
                } else {
                    message.error({ content: response.message, duration: 2 });
                }
            } catch (error: any) {
                message.error({ content: error.message as string, duration: 1 });
            } finally {
                setLoading(false);
            }
        }
    };

    const move = async (id: any, type: string, flagUpDown: boolean) => {
        setLoading(true);
        try {
            const response = await homeService.moveUpDown(id, null, type, flagUpDown);
            if (response.code === 0) {
                const values = await form.validateFields();
                setCurrentPage(currentPage);
                fetchData(currentPage, values.keySearch);
            } else {
                message.error({ content: response.message, duration: 2 });
            }
        } catch (error: any) {
            message.error({ content: error.message as string, duration: 1 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <div className="container-fluid" style={{ paddingTop: '10px' }}>
                {/* Page Heading */}
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0" style={{ color: '#951a1d' }}>Nhân Sự / Cộng Đoàn</h1>
                </div>
                {/* Content Row */}
                <Form form={form} name="search" onFinish={refreshData}>
                    <div className="row">
                        <div className='col-xl-3 col-md-6'>
                            <div className="form-group">
                                <Form.Item name="keySearch">
                                    <Input className='form-control' placeholder="Tìm kiếm theo tên Cộng Đoàn" autoComplete="off" />
                                </Form.Item>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className='row'>
                                <div className='col-12 text-right'>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading && (
                                                <span className='spinner-border spinner-border-sm mr-1'></span>
                                            )}
                                            Lọc dữ liệu
                                        </button>
                                        <Link type="button" className="btn btn-info ml-2" to="/cong-doan/them-moi" >Tạo mới</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
                <div className="row">
                    <div className="col-12">
                        <div className='text-right mb-2'>
                            <Pagination
                                current={currentPage}
                                total={totalItems}
                                pageSize={MAX_ITEMS_PER_PAGE}
                                onChange={onPageChanged}
                                showSizeChanger={false}
                            />
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing={0}>
                                <thead style={{ backgroundColor: '#fac2b5' }}>
                                    <tr>
                                        <th>Tên cộng đoàn</th>
                                        <th>Vùng</th>
                                        <th>Cha bề trên</th>
                                        <th>Thứ tự</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        // Hiển thị bộ Loading khi loadingLoadList là true
                                        <tr className='text-center'>
                                            <td colSpan={6}>
                                                <span className='spinner-border spinner-border-sm mr-1'></span> Đang tải...
                                            </td>
                                        </tr>
                                    ) : (
                                        // Hiển thị bảng dữ liệu khi loadingLoadList là false
                                        <Fragment>
                                            {lstDanhSach?.map((item, index) => (
                                                <tr key={index} className={index % 2 === 0 ? 'col-bg-0' : 'col-bg-1'}>
                                                    <td>{item.tenCongDoan}</td>
                                                    <td>{item.vung?.tenVung}</td>
                                                    <td>{item.chaBeTren?.user?.firstName + ' ' + item.chaBeTren?.user?.lastName}</td>
                                                    <td style={{ width: '10%' }}>
                                                        <MoveButtons onMoveUp={() => move(item.id, 'CONG_DOAN', true)} onMoveDown={() => move(item.id, 'CONG_DOAN', false)} />
                                                    </td>
                                                    <td style={{ display: 'flex' }}>
                                                        <Link to={`/cong-doan/chinh-sua/${item.id}`} style={{ marginLeft: '10px' }}>
                                                            {/* Chèn nội dung bên trong thẻ Link */}
                                                            <img style={{ width: '22px' }} src='/images/web_new.png' alt={item.ma} />
                                                        </Link>
                                                        <img onClick={() => handleDelete(item.id)} style={{ width: '23px', cursor: 'pointer', marginLeft: '10px' }} src='/images/web_delete.png' alt={item.ma} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </Fragment>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className='text-right'>
                            <Pagination
                                current={currentPage}
                                total={totalItems}
                                pageSize={MAX_ITEMS_PER_PAGE}
                                onChange={onPageChanged}
                                showSizeChanger={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
